<form class="main-container" #form="ngForm">
  <div class="loader-container" *ngIf="isLoading">
    <app-loader message="Chargement..."></app-loader>
  </div>

  <div class="livraison-header">
    <label class="elior-label">Relivraison le </label>
    <span class="heure-jour no-wrap">{{ relivraisonDate | dateFormat:'DD/MM/YYYY à HH:mm' }}</span>
  </div>
<!--
  <div>
    {{ model.bonLivraison | json }}
  </div> -->

    <div class="prestation-container" *ngFor="let prestation of relivraisonPrestations">
    <div class="prestation-libelle restaurant-type-background">{{ prestation.libelle }}</div>
    <div *ngFor="let famillePlat of prestation.bonLivraisonFamillePlats | filterAllowedFamillePlat:model.bonLivraison.settings">
      <div class="famille-plat-libelle">{{ famillePlat.libelle }}</div>
      <div *ngFor="let plat of famillePlat.bonLivraisonPlats">
        <div class="plat-section">
          <div class="plat-libelle">{{ plat.libelle }}</div>
          <div class="plat-temperature">
            <app-livraison-temperature [plat]="plat" [platTemperatureProperty]="'relivraisonTemperature'" [settings]="model.bonLivraison.settings" [isModifiable]="true" (temperatureChanged)="onTemperatureChanged()" ></app-livraison-temperature>
          </div>
          <!-- <div class="plat-dlc">
            <app-livraison-dlc [plat]="plat" [dateDLCMin]="model.bonLivraison.dateDLCMin" [isModifiable]="model.bonLivraison.peutLivrer"></app-livraison-dlc>
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <p class="nonconformites-intro" *ngIf="hasPlatFaults">Vous avez relevé les non-conformités suivantes: </p>
  <div class="container-nonconformites" *ngIf="hasPlatFaults">
    <div class="container-nonconformite-temperature" *ngIf="hasNonConformiteTemperature">
      <h3>TEMPERATURE</h3>
      <div class="nonconformite-temperature-item" *ngFor="let ncPlat of nonConformiteTemperaturePlats">
        <div class="temperature temperature-color-{{ TemperatureStatusEnum[ncPlat.status] }}">{{ ncPlat.plat.relivraisonTemperature | formatTemperature:'°C' }}</div>
        <div class="plat">{{ ncPlat.plat.libelle }}</div>
      </div>
    </div>
    <!-- <div class="container-nonconformite-dlc" *ngIf="hasNonConformiteDlc">
      <h3>DLC/DDM</h3>
      <div class="nonconformite-dlc-item" *ngFor="let ncPlat of nonConformiteDlcPlats">
        <div class="dlc dlc-color-{{ DLCStatusEnum[ncPlat.status] }}">{{ ncPlat.plat.relivraisonDLC | dateFormat }}</div>
        <div class="plat">{{ ncPlat.plat.libelle }}</div>
      </div>
    </div> -->
  </div>

  <div class="livraison-signaturepad">
    <h3>SIGNATURE</h3>
    <ng-container *ngIf="allowRelivraison; else elseDisplaySignatureImageTemplate">
      <app-livraison-signature></app-livraison-signature>
    </ng-container>
    <ng-template #elseDisplaySignatureImageTemplate>
      <div class="signature-image-container">
        <ng-container *ngIf="this.model.bonLivraison.relivraisonSignature; else elseNoSignatureImageTemplate">
          <img src="{{this.model.bonLivraison.relivraisonSignature}}" />
        </ng-container>
        <ng-template #elseNoSignatureImageTemplate>
          <span>Signature indisponible sur ce bon</span>
        </ng-template>
      </div>
    </ng-template>
  </div>

  <div class="commentaire-container" *ngIf="allowRelivraison">
    <h3><label for="commentaire">COMMENTAIRE</label></h3>
    <textarea [(ngModel)]="commentaire" name="commentaireControl" #commentaireControl="ngModel" placeholder="Veuillez indiquer un commentaire / plan d'action" [required]="isCommentaireRequired" minlength="3" autocomplete="off" (focus)="scrollToElement(buttonContainer)" (input)="scrollToElement(buttonContainer)">
            </textarea>
    <div *ngIf="(form.submitted || form.dirty || form.touched ) && !commentaireControl.valid">
      <div *ngIf="commentaireControl.errors['required']" class="error-message">Le commentaire est requis.</div>
      <div *ngIf="commentaireControl.errors['minlength']" class="error-message">Le commentaire doit contenir au moins 3 caractères.</div>
    </div>
  </div>

  <div class="validation-error error-message" *ngIf="erreurValidationMessage != ''">
    {{ erreurValidationMessage }}
  </div>

  <div class="button-container" #buttonContainer>
    <button class="generic-button" (click)="hide()">Annuler</button>
    <button class="generic-button validate-button green-button" (click)="DeclarerLivraison(true)" *ngIf="allowRelivraison">Conforme</button>
    <button class="generic-button revoke-button red-button" (click)="DeclarerLivraison(false)" *ngIf="allowRelivraison">Non conforme</button>
  </div>
</form>
